//----- Component --------------------------------------------------------/
// Developer     : Guillermo Sedran
// Creation Date : 30/01/2025
// Version       : 1
// Description   : Tabla que muestra las partes del vehículo con su/s observacion/es correspondiente/s
//
//------Changes --------------------------------------------------------------------- -------------//
// Change Date   : 23/06/2025
// Change by     : Guillermo Sedran
// Change description: Cambios esillo, refactor
//
// Change Date   :
// Change by     :
// Change description:
//
//========================================================================/

import { useState, useEffect, useMemo } from "react";
import { UrlApi } from "../../../services/apirest";
import { MaterialReactTable } from "material-react-table";
// TABLA EN ESPAÑOL
import { MRT_Localization_ES } from "material-react-table/locales/es";

import {
  Box,
  Dialog,
  DialogContent,
  Typography,
  IconButton,
  ThemeProvider,
  createTheme,
  useTheme,
  AppBar,
  Toolbar,
} from "@mui/material";

// ICONOS
import CloseIcon from "@mui/icons-material/Close";

function ObservacionesRevision(props) {
  const globalTheme = useTheme();

  const [vehiculo, setVehiculo] = useState(props.vehiculo);
  const [observaciones, setObservaciones] = useState({});

  //   -------------------------------------------------------------------
  const obtenerObservaciones = () => {
    const fechaFormateada = vehiculo.ultima_fecha.replace(/\//g, "-"); // Reemplaza "/" por "-"

    fetch(
      `${UrlApi}/vehiculos_revision/revision_por_fecha/solo_observacion/${vehiculo.id}/${fechaFormateada}`
    )
      .then((data) => data.json())
      .then((data) => {
        setObservaciones(data);
      });
  };

  useEffect(() => {
    obtenerObservaciones();
  }, []);

  //*************************************************************************************************************************************/
  // ----------- TABLA ---------------
  const columns = [
    { accessorKey: "parte_vehiculo", header: "Parte", size: 60 },
    { accessorKey: "tarea", header: "Tarea", size: 100 },
    { accessorKey: "observacion", header: "Observación", size: 150 },
  ];

  const customLocalization = {
    ...MRT_Localization_ES,
    body: {
      ...MRT_Localization_ES.body,
      noData: "No hay registros para mostrar",
    },
  };

  const initialState = {
    density: "compact",
    showGlobalFilter: true, // Mostrar la barra de búsqueda
    pagination: { pageIndex: 0, pageSize: 10 },
    grouping: ["parte_vehiculo"],
  };

  const tableHeadCellProps = {
    align: "left",
    sx: {
      fontSize: 16,
      color: "white",
      fontWeight: "normal",
      backgroundColor: "#2471A3",
      borderColor: "black",
    },
  };

  const muiSearchTextFieldProps = {
    placeholder: "Buscar..",
    sx: { backgroundColor: "#ffffff" },
    variant: "outlined",
    size: "small",
  };

  const tableTheme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: globalTheme.palette.mode,
          primary: globalTheme.palette.primary,
          info: {
            main: "rgb(255,122,0)",
          },
          background: {
            default:
              globalTheme.palette.mode === "light"
                ? "rgb(234, 239, 241)"
                : "#000",
          },
        },
        typography: {
          button: {
            textTransform: "none",
            fontSize: "1rem",
          },
        },
        components: {
          MuiTooltip: {
            styleOverrides: {
              tooltip: {
                fontSize: "0.8rem",
              },
            },
          },
        },
      }),
    [globalTheme]
  );

  //*************************************************************************************************************************************/

  const handleClose = () => {
    props.onClose(); // Cerrar el diálogo
  };

  return (
    <Dialog fullScreen open={props.open} onClose={props.onClose}>
      <AppBar sx={{ position: "relative" }}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={handleClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>

          <Box
            sx={{ ml: 2, flex: 1, display: "flex", flexDirection: "column" }}
          >
            <Box
              sx={{
                display: "inline-flex",
                alignSelf: "flex-start",
                border: "1px solid #0d47a1",
                borderRadius: "16px",
                overflow: "hidden",
                fontWeight: "bold",
                fontSize: "0.875rem", // similar a un Chip
              }}
            >
              <Box
                sx={{
                  backgroundColor: "#0d47a1",
                  color: "white",
                  padding: "4px 8px",
                  whiteSpace: "nowrap",
                  borderTopLeftRadius: "16px",
                  borderBottomLeftRadius: "16px",
                }}
              >
                Patente
              </Box>
              <Box
                sx={{
                  backgroundColor: "white",
                  color: "#0d47a1",
                  paddingTop: "4px",
                  paddingLeft: "6px",
                  paddingRight: "12px",
                  whiteSpace: "nowrap",
                  borderTopRightRadius: "16px",
                  borderBottomRightRadius: "16px",
                }}
              >
                {vehiculo.patente}
              </Box>
            </Box>
          </Box>
        </Toolbar>
      </AppBar>

      <DialogContent>
        <Box
          sx={{
            marginTop: "10px",
            marginBottom: "25px",
            marginLeft: "30px",
            marginRight: "30px",
          }}
        >
          <ThemeProvider theme={tableTheme}>
            <MaterialReactTable
              columns={columns}
              data={observaciones}
              enableGlobalFilter={true}
              enableToolbarInternalActions={true}
              initialState={initialState}
              positionActionsColumn="last"
              autoResetPageIndex={false}
              enableDensityToggle={false}
              enableFullScreenToggle={false}
              enableColumnActions={true}
              enableColumnFilters={false}
              enableHiding={false}
              enableGrouping={true}
              localization={customLocalization}
              enableRowSelection={false}
              enableRowActions={false}
              muiTableHeadCellProps={tableHeadCellProps}
              muiSearchTextFieldProps={muiSearchTextFieldProps}
              renderTopToolbarCustomActions={() => (
                <Typography variant="poster" fontSize={26}>
                  Observaciones
                </Typography>
              )}
            />
          </ThemeProvider>
        </Box>
      </DialogContent>
    </Dialog>
  );
}

export default ObservacionesRevision;
